import React, {useContext} from "react";
import HeadBrandingWidget from "../../widgets/HeadBrandingWidget";
import "./DashboardHeader.scss";

import {useNavigate} from "react-router-dom";
import Select from "react-select";
import LeaderboardIcon from '@mui/icons-material/Leaderboard';

import {LoginContext} from "../../context/login.context";
import {CurrentRaceEventContext} from "../../context/currentRaceEvent.context";
import resultsLayout from "../../utils/layout/resultsDashboardLayout.json";

export interface RaceScheduleHeaderProps {
    leftContent?: React.ReactNode;
    isInRaceDashboard?: boolean;
    eventId?: string;
}

const classNames = {
    control: () => "selectControl",
    indicatorsContainer: () => "indicatorsContainer",
    indicatorSeparator: () => "indicatorSeparator",
    valueContainer: () => "valueContainer",
    input: () => "selectInput",
    singleValue: () => "singleValue",
    placeholder: () => "selectPlaceholder",
    container: () => "selectContainer",
    menuList: () => "menuList",
    option: () => "selectOption",
    menu: () => "selectMenu",
};

export const DashboardHeader = (props: RaceScheduleHeaderProps) => {
    const navigate = useNavigate();
    const {currentEvent} = useContext(CurrentRaceEventContext)


    const options = [
        {value: "/raceManagement", label: "RACE DASHBOARD"},
        {value: "/video", label: "VIDEO DASHBOARD"},
        {value: "/chatter", label: "CHATTER DASHBOARD"},

    ];

    if (currentEvent && currentEvent.eventSeason >= 5) {
        options.push({value: "/results", label: "RESULTS DASHBOARD"})
    }


    const {isVip, logOut} = useContext(LoginContext);

    const onLogout = async (data: any) => {
        logOut();
    };

    return (
        <div className="dashboardHeader">
            <button
                onClick={() => {
                    navigate("/schedule");
                }}
                className={`headerBrandingContainer ${
                    !props.isInRaceDashboard ? "headerBrandingContainer--schedule" : ""
                }`}
            >
                <HeadBrandingWidget/>
            </button>

            <div className="leftContentContainer">{props.leftContent ?? null}</div>
            {props.isInRaceDashboard && (
                <div className="headerNavigationContainer">
                    <Select
                        className="dashboardSelector"
                        placeholder="CHANGE LAYOUT"
                        onChange={(e) => e && e.value && navigate(e.value)}
                        options={options}
                        unstyled
                        openMenuOnClick={true}
                        isClearable={false}
                        isSearchable={false}
                        classNames={classNames}
                    />
                </div>
            )}


            <div className="dashboardProfile">
                {currentEvent && currentEvent.eventSeason >= 5 && (
                    <button
                        className="dashboardButton dashboardButton__leaderboard"
                        onClick={() => {
                            navigate(`/season-leaderboard/${currentEvent.eventSeason}`);
                        }}
                    >
                        <LeaderboardIcon className="dashboardButton__icon" />
                        STANDINGS
                    </button>
                )}
                {!isVip && (
                    <>
                        <button
                            className="dashboardButton dashboardButton__settings"
                            onClick={() => {
                                navigate("/settings");
                            }}
                        >
                            <img
                                className="dashboardButton__icon"
                                src="/Setting_fill.svg"
                                alt=""
                            />
                            SETTINGS
                        </button>
                        <a onClick={onLogout} className="dashboardButton" href="/">
                            <img
                                className="dashboardButton__icon"
                                src="/Sign_in_circle_disabled.svg"
                                alt=""
                            />
                            LOG OUT
                        </a>
                    </>
                )}
            </div>

        </div>
    );
};
